var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEn = function SvgEn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#en_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40 0v5L25.156 20 40 34.61V40h-5.234L19.844 25.312 5.312 40H0v-5.313l14.531-14.609L0 5.781V0h4.844l15 14.688L34.375 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8102E",
    d: "m14.375 25.313.86 2.656L3.28 40H0v-.234zm9.688-.938L28.28 25 40 36.484V40zM40 0 25 15.313l-.313-3.438L36.407 0zM0 .078l15.078 14.766-4.61-.625L0 3.829z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.75 0v40h12.5V0zM0 13.75v12.5h40v-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8102E",
    d: "M0 16.25v7.5h40v-7.5zM16.25 0v40h7.5V0z"
  }))));
};
export default SvgEn;